import React from 'react'
import { XIcon } from '../../icons'

type Props = {
    isOpen: boolean
    onClose: () => void
    title: string
    children: React.ReactNode
    footer?: React.ReactNode
    maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '8xl' | '5xl' | '6xl' | '7xl'
    showCloseButton?: boolean
    icon?: React.ReactNode
}

const maxWidthClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    '5xl': 'max-w-5xl',
    '6xl': 'max-w-6xl',
    '7xl': 'max-w-7xl',
    '8xl': 'max-w-8xl'
}

export const Modal = (props: Props) => {
    const { isOpen, onClose, title, children, footer, maxWidth = 'lg', showCloseButton = true, icon } = props

    if (!isOpen) return null

    return (
        <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
            {/* Background overlay */}
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" onClick={onClose}></div>

            {/* Modal panel */}
            <div className="flex min-h-full items-center justify-center p-4">
                <div className={`relative transform overflow-hidden rounded-lg bg-white dark:bg-gray-800 text-start shadow-xl transition-all w-full ${maxWidthClasses[maxWidth]}`}>
                    {/* Header */}
                    <div className="bg-white dark:bg-gray-800 px-6 py-4 border-b border-gray-200 dark:border-gray-700">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-3">
                                {icon && (
                                    <div className="flex-shrink-0">
                                        {icon}
                                    </div>
                                )}
                                <h3 className="text-2xl font-semibold text-gray-900 dark:text-gray-100" id="modal-title">
                                    {title}
                                </h3>
                            </div>
                            {showCloseButton && (
                                <button
                                    type="button"
                                    className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
                                    onClick={onClose}
                                >
                                    <span className="sr-only">Close</span>
                                    <XIcon className="h-6 w-6" />
                                </button>
                            )}
                        </div>
                    </div>

                    {/* Content */}
                    <div className="bg-white dark:bg-gray-800">
                        {children}
                    </div>

                    {/* Footer */}
                    {footer && (
                        <div className="bg-gray-50 dark:bg-gray-900 px-6 py-4">
                            {footer}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
